import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { api, setToken } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  // null = checking, false = signed out, object = user
  const [user, setUser] = useState(null);
  const version = useRef(0);

  const refresh = useCallback(async () => {
    const v = version.current;
    try {
      const { data } = await api.get("/auth/me", { timeout: 15000 });
      if (v === version.current) setUser(data);
    } catch {
      if (v === version.current) setUser(false);
    }
  }, []);

  useEffect(() => {
    // Returning from Google: AuthCallback exchanges the session first.
    if (window.location.hash?.includes("session_id=") || window.location.pathname === "/magic") return;
    refresh();
  }, [refresh]);

  const signIn = useCallback((data) => {
    version.current += 1;
    setToken(data.token);
    setUser(data.user);
  }, []);
  const signOut = async () => {
    version.current += 1;
    try {
      await api.post("/auth/logout");
    } catch {}
    setToken(null);
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, setUser, signIn, signOut, refresh }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
